import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onCompleted"],
    _excluded2 = ["fetchMore"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useLazyQuery } from '@apollo/client';
import { flow } from 'fp-ts/function';
import { useApolloResult } from '../use-apollo-result';
export function makeLazyDecodedQuery(query, output, input) {
  return Object.assign(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onCompleted = _ref.onCompleted,
        options = _objectWithoutProperties(_ref, _excluded);

    var _useLazyQuery = useLazyQuery(query, _objectSpread({
      onCompleted: onCompleted === undefined ? undefined : flow(output.decode, onCompleted)
    }, options)),
        _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
        runQuery = _useLazyQuery2[0],
        _useLazyQuery2$ = _useLazyQuery2[1],
        fetchMore = _useLazyQuery2$.fetchMore,
        queryResult = _objectWithoutProperties(_useLazyQuery2$, _excluded2);

    return [runQuery, useApolloResult(_objectSpread(_objectSpread({}, queryResult), {}, {
      output: output
    })), {
      fetchMore: fetchMore
    }];
  }, _objectSpread({
    document: query,
    output: output
  }, input ? {
    input: input
  } : {}));
}